import { useMutation } from '@tanstack/react-query';
import { OrganizationDto, UpdateOrganizationWhatsAppLinksDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useUpdateWhatsAppLinks = (organizationId: string, onSuccess: (data: OrganizationDto) => void) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateWhatsAppLinks', organizationId],
        mutationFn: (body: UpdateOrganizationWhatsAppLinksDto) => apiClient.fetchApi<OrganizationDto, UpdateOrganizationWhatsAppLinksDto>({ method: 'POST', endpoint: `organizations/${organizationId}/whatsapp-links`, body }),
        onSuccess: (data) => {
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
            onSuccess(data);
        },
    });
};
